// Central media map. Fill URLs in as assets are produced; `null` renders an
// on-brand "coming soon" placeholder so the layout never breaks.
export const MEDIA_BASE = "/api/htt";

// Landing trailer.
export const TRAILER = `${MEDIA_BASE}/media/HTT.mp4`;

// Per-module films (the "watch the film" moment before each practice room).
export const MODULE_FILMS = {
  1: `${MEDIA_BASE}/media/HTT.mp4`,
  2: null,
  3: null,
  4: null,
  5: null,
  6: null,
  7: null,
  8: null,
};

// Figures / graphs / diagrams to be supplied. `src: null` => placeholder frame.
export const FIGURES = [
  { id: "seven-stages", label: "The Seven Stages", caption: "Spoken · Heard · Recorded · Interpreted · Decided · Acted · Seen", src: `${MEDIA_BASE}/media/figures/seven-stages.jpg` },
  { id: "four-leaks", label: "The Four Leaks", caption: "Where good training stops changing conditions", src: `${MEDIA_BASE}/media/figures/four-leaks.jpg` },
  { id: "practice-picture", label: "Your Practice Picture", caption: "Movement over attendance — your own evidence", src: `${MEDIA_BASE}/media/figures/practice-picture.jpg` },
];
